export default "__VITE_ASSET__D4XtyZ1H__"